import { mapActions, mapGetters } from 'vuex';
import $ from 'jquery';

export const HubMemberMixin = {
  mixins: [],
  data() {
    return {
      loading_member_data: 0,
      loading_player_data: 0,
      loading_manager_data: 0,
      member_start: 0,
      member_end: 14,
      hideTextLoadMoreMember: false,
      list_hub_member_info_load_more: {},
    };
  },
  computed: {
    ...mapGetters('hub', ['hubData', 'hubUserData', 'currentTab', 'hubModal',
      'list_hub_leader_info',
      'list_hub_admin_info',
      'list_hub_member_info',
      'count_hub_leader',
      'count_hub_admin',
      'count_hub_member',
    ]),
    ...mapGetters('app', ['appConfig']),
  },
  methods: {
    ...mapActions({
      setHubModal: 'hub/setHubModal',
      setHubData: 'hub/setHubData',
      setListHubLeaderInfo: 'hub/setListHubLeaderInfo',
      setListHubAdminInfo: 'hub/setListHubAdminInfo',
      setListHubMemberInfo: 'hub/setListHubMemberInfo',
      setCountHubLeader: 'hub/setCountHubLeader',
      setCountHubAdmin: 'hub/setCountHubAdmin',
      setCountHubMember: 'hub/setCountHubMember',
    }),
    getHubMemberData() {
      this.loading_member_data = 1;
      this.$http.post('/hub/get-hub-member-data', {
        hub_id: this.hubData.hub_data.id,
      }, {
        headers: {
          'X-CSRF-TOKEN': this.appConfig.csrfToken,
        },
      })
        .then(response => {
          this.loading_member_data = 0;
          this.setCountHubLeader(response.data.count_hub_leader);
          this.setCountHubAdmin(response.data.count_hub_admin);
          this.setCountHubMember(response.data.count_hub_member);
          this.member_start = 0;
          this.member_end = 14;
          if (response.data.count_hub_member < 15) {
            this.hideTextLoadMoreMember = true;
          }
          if (this.list_hub_member_info.length >= this.count_hub_member) {
            this.hideTextLoadMoreMember = true;
          }
          // set member data to vuex
          this.hubData.count_member = this.count_hub_member;
          this.hubData.count_admin = this.count_hub_admin;
          this.hubData.count_leader = this.count_hub_leader;
          this.hubData.count_all_member = parseInt(this.count_hub_member) + parseInt(this.count_hub_admin) + parseInt(this.count_hub_leader);
          this.setHubData(this.hubData);
          this.setListHubMemberInfo(response.data.list_hub_member_info);
          this.setListHubAdminInfo(response.data.list_hub_admin_info);
          this.setListHubLeaderInfo(response.data.list_hub_leader_info);
        })
        .catch(error => {
          console.log('getHubMemberData error request');
          console.log(error);
        }).finally(() => {
          this.loading_member_data = 0;
        });
    },
    initScrollLoadMoreMemberSetting() {
      const self = this;
      $('#community_settings_member_section').scroll(function() {
        if ($('#community_settings_member_section').scrollTop() + $('#community_settings_member_section').innerHeight() >= $('#community_settings_member_section').prop('scrollHeight')) {
          self.loadMoreMember();
        }
      });
    },
    loadMoreMember() {
      this.member_start = this.member_end + 1;
      this.member_end = this.member_start + this.MEMBER_LOADMORE;
      this.$http.post('/hub/load-more-member', {
        hub_id: this.hubData.hub_data.id,
        member_start: this.member_start,
        member_end: this.member_end,
      }, {
        headers: {
          'X-CSRF-TOKEN': this.appConfig.csrfToken,
        },
      })
        .then(response => {
          this.list_hub_member_info_load_more = response.data.list_hub_member_info_load_more;
          this.list_hub_member_info_load_more.forEach(i => {
            this.list_hub_member_info.push(i);
          });
          if (this.list_hub_member_info.length >= this.count_hub_member) {
            this.hideTextLoadMoreMember = true;
          }
        })
        .catch(error => {
          console.log('loadMoreMember error request');
          console.log(error);
        });
    },
  },
};
